import React from 'react';
import Language from 'services/Language.js';
import { NavLink } from "react-router-dom";
import SelectSearch from 'react-select-search';
import CryptoModalVerifications from '../../../widgets/CryptoModalVerifications';
import CryptoModalVerificationsSucces from '../../../widgets/CryptoModalVerificationsSucces';
import WalletDesc from './component/WalletDesc';
import {connect} from "react-redux";
import {getDataToVerifyCryptoAddressRequest} from "../../../actions/cryptoAddressVerification";
import {currenciesTypes} from "../../../constant/Currencies";
import utils from "../../../services/utils";
import CryptoAddressVerification from "../../../entity/CryptoAddressVerification";
import CommonUpdater from 'services/CommonUpdater.js';
import {Accordion, AccordionItem} from 'component/Accordion';

export const ACTIONS = {
    BEGINED_VERIFICATION_PROCESS: 'beginedVerificationProcess',
    SHOW_RESULT: 'showResult',
}

class CryptoVerification extends React.Component {
    constructor(props) {
        super(props);

        this.openModal = this.openModal.bind(this);
        this._onChangeCurrency = this._onChangeCurrency.bind(this);
        this._onChangeAddress = this._onChangeAddress.bind(this);
        this.updateVerificationStatus = this.updateVerificationStatus.bind(this);
        this.reset = this.reset.bind(this);

        this.state = {
            isDisabledAddress: true,
            address: '',
            currencyShortNameToCheck: '',
            cryptoAddressVerification: new CryptoAddressVerification(),
            action: null
        }
    }

    componentWillMount() {
        if (!this.props.availableCurrencies.loaded) {
            this.props.dispatch(getDataToVerifyCryptoAddressRequest());
        }
    }

    componentDidUpdate() {
        if (this.props.availableCurrencies.loaded && this.state.currencyShortNameToCheck === '') {
            this.setState({
                currencyShortNameToCheck: (this.props.availableCurrencies.dataForSelect.length) ? this.props.availableCurrencies.dataForSelect[0].name : '',
            })
        }
    }

    openModal() {
        if (this.state.address) {
            CryptoModalVerifications.showModal(
                utils.getLocalizeUrl('/api/crypto-address/add-crypto-address-verification'),
                {
                    address: this.state.address,
                    currencyShortNameToCheck: this.state.currencyShortNameToCheck,
                },
                this.getCurrenciesForPaidData(),
                this.props.availableCurrencies.cryptoAddressVerification,
                this.updateVerificationStatus
        );
        } else {
            $('input[name="crypto_wallet_address"]').focus();
            utils.app_noty({
                type: 'error',
                text: Language.getLabel('L_FILL_IN_THE_ADDRESS'),
            });
        }
    }

    _onChangeCurrency(currencyShortNameToCheck) {
        this.setState({
            isDisabledAddress: false,
            currencyShortNameToCheck: currencyShortNameToCheck
        })
    }

    _onChangeAddress(event) {
        this.setState({
            address: event.target.value,
        })
    }

    getCurrenciesForPaidData() {
        let currenciesForPaidData = [];
        for (let currencyId in this.props.wallets) {
            let currency = this.props.currencies.data.get(+currencyId);
            if (currency &&
                currency.enabled &&
                currency.showInUserWallets &&
                this.props.wallets[currencyId].balance > 0
            ) {
                currenciesForPaidData.push({
                    'key'  : currency.shortName,
                    'value': currency.shortName,
                    'name' : utils.getDisplayOrRealName(currency),
                    'linkToIcon' : currency.linkToIcon
                });
            }
        }

        return currenciesForPaidData;
    }

    updateVerificationStatus(action, data) {
        switch (action) {
            case ACTIONS.BEGINED_VERIFICATION_PROCESS:
                CryptoModalVerifications.close(() => {CryptoModalVerificationsSucces.showModal()});
                this.setState({
                    action: ACTIONS.BEGINED_VERIFICATION_PROCESS
                });
                break;
            case ACTIONS.SHOW_RESULT:
                this.setState({
                    cryptoAddressVerification: data,
                    action: ACTIONS.SHOW_RESULT,
                    address: ''
                });

                CommonUpdater.updateTask([CommonUpdater.GET_BALANCE_AND_SUM, CommonUpdater.GET_BONUSES_BALANCE]);

                break;
            default:
                CryptoModalVerificationsSucces.close(() => {});
                this.setState({
                    action: null
                });
        }
    }

    reset() {
        this.setState({
            cryptoAddressVerification: new CryptoAddressVerification(),
        });
    }

    _createAccordionItem() {
        let items = [];
        if(Object.keys(this.state.cryptoAddressVerification.data).length) {
            Object.keys(this.state.cryptoAddressVerification.data).map((item) => {
                items.push(<div className="signalsAttributes__item"
                    key={`accordionItem_${this.state.cryptoAddressVerification.id}_${item}`}>
                    <div className="label">{Language.getLabel('L_' + item.toUpperCase())}:
                        <div className="value">{this.state.cryptoAddressVerification.data[item]}</div>
                    </div>

                </div>);
            });
        }

        return <AccordionItem key={this.state.cryptoAddressVerification.id}
                       title={
                           <span className="accordion-header">
                               {this._getWalletDesc()}
                           </span>
                       }>
                    {items.length > 0 &&
                        <div className="signalsAttributes">
                            {items}
                        </div>
                    }
        </AccordionItem>
    }

    _getWalletDesc() {
        return <WalletDesc
            currency={ this.props.currencies.data.get(this.state.cryptoAddressVerification.currencyToCheckId) }
            address={this.state.cryptoAddressVerification.address}
            status={this.state.cryptoAddressVerification.status}
            reset={this.reset}
        />
    }

    render() {
        return (
            <div className="crypto-verification-page">
                <div className="crypto-verification-page__header">
                    <div className="crypto-verification-page__header-left">
                        <h1 className="crypto-verification-page__title">{Language.getLabel('L_CRYPTO_ADDRESS_VERIFICATION')}</h1>
                    </div>

                    <NavLink className="crypto-verification-page__link-page" to="/history-checks">
                        {Language.getLabel('L_CRYPTO_LINK_1')}
                    </NavLink>
                </div>

                <div className="crypto-verification-page__body">
                    <div className="crypto-verification-page__control-block">
                        <div className="crypto-verification-page__controls">
                            <div className="crypto-verification-page__controls-item crypto-verification-page__controls-item--currency">
                                <div className="crypto-verification-page__controls-form">
                                    <div className="crypto-verification-page__label">
                                        {Language.getLabel('L_CRYPTO_LABEL_SELECT')}
                                    </div>
                                    <SelectSearch
                                        options={this.props.availableCurrencies.dataForSelect}
                                        onChange={this._onChangeCurrency}
                                        search
                                        renderOption={(props, { stack, name, linkToIcon }, snapshot, className) => {
                                            let classNoUrl = 'select-search__option__img--url-false';
                                            if (linkToIcon) {
                                                classNoUrl = '';
                                            }

                                            return (
                                                <button {...props} className={className} type="button">
                                                    <span
                                                        className={`${className} select-search__option__img ${classNoUrl}`}
                                                        style={{ backgroundImage: "url(" + linkToIcon + ")" }} />
                                                    <span>{name}</span>
                                                </button>
                                            );
                                        }}

                                        renderValue={(valueProps, snapshot, className) => {
                                            const { option, value } = snapshot;
                                            const style = {
                                                fontFamily: (!snapshot.focus && option && 'stack' in option) ? option.stack : null,
                                            };
                                            const inputVal = snapshot.displayValue;
                                            const linkToIcon = (typeof value === 'object' && value !== null && value.hasOwnProperty('linkToIcon')) ? value.linkToIcon : '';

                                            let classNoUrl = 'select-search__option__img--url-false';
                                            if (linkToIcon) {
                                                classNoUrl = '';
                                            }

                                            return (
                                                <span className={ "select-search__value-custom" }>
                                                     <span
                                                         className={`${className} select-search__option__img ${classNoUrl}`}
                                                         style={{ backgroundImage: "url(" + linkToIcon + ")" }} />
                                                     <input {...valueProps} className={className} style={style} value={inputVal} />
                                                </span>
                                            );
                                        }}
                                        value={this.state.currencyShortNameToCheck}
                                        disabled={!this.props.availableCurrencies.loaded}
                                    />
                                </div>
                            </div>

                            <div className="crypto-verification-page__controls-item crypto-verification-page__controls-item--wallet">
                                <div className="crypto-verification-page__controls-form">
                                    <label className="crypto-verification-page__label" htmlFor="crypto_wallet_address" >
                                        {Language.getLabel('L_CRYPTO_LABEL_ADRESS')}
                                    </label>
                                    <input className="crypto-verification-page__input"
                                           type="text"
                                           name="crypto_wallet_address" placeholder={Language.getLabel('L_CRYPTO_LABEL_ADRESS')}
                                           onChange={this._onChangeAddress}
                                           value={this.state.address}
                                    />
                                </div>
                            </div>
                            <div className="crypto-verification-page__controls-item crypto-verification-page__controls-item--button">
                                <div className="crypto-verification-page__controls-button">
                                    <button className="button button--green crypto-verification-page__button" type="button" onClick={this.openModal}>
                                        {this.state.action === ACTIONS.BEGINED_VERIFICATION_PROCESS &&
                                            <svg className="icon icon--img-crypto-loader" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="9" stroke="#66D7C5" strokeWidth="2" />
                                                <path d="M19 10C19 14.9706 14.9706 19 10 19" stroke="#A5ABB0" strokeWidth="2" />
                                                <path d="M19 10C19 14.9706 14.9706 19 10 19" stroke="white" strokeWidth="2" />
                                            </svg>
                                        }
                                        <span className="crypto-verification-page__button-text">
                                            {this.state.action !== ACTIONS.BEGINED_VERIFICATION_PROCESS &&
                                                Language.getLabel('L_CRYPTO_VERIFICATION_BTN')
                                            }

                                            {this.state.action === ACTIONS.BEGINED_VERIFICATION_PROCESS &&
                                                Language.getLabel('L_CRYPTO_VERIFICATION_BTN_VER')
                                            }
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className={"attention"}>
                            {Language.getLabel('L_COST_OF_CHECKING_ONE_ADDRESS_COSTS', {
                                amount: this.props.availableCurrencies.cryptoAddressVerification.cost,
                                currencyShortName: utils.getDisplayOrRealName(this.props.availableCurrencies.cryptoAddressVerification.currencyPayment)
                            })}
                        </div>

                        {!!this.state.cryptoAddressVerification.id &&
                            <div className="crypto-verification-page__wallet-desc">
                                {Object.keys(this.state.cryptoAddressVerification.data).length ?
                                    (<Accordion
                                        initialOpenedKey={this.state.cryptoAddressVerification.id}
                                        blockTitleClass="accordion-title"
                                        closedTitleClass="accordion-title_closed"
                                        openedTitleClass="accordion-title_opened"
                                        blockBodyClass="accordion-body"
                                        closedBodyClass="accordion-body_hidden"
                                        openedBodyClass="accordion-body_shown"
                                    >
                                        {[this._createAccordionItem()]}
                                    </Accordion>)
                                    :
                                    (this._getWalletDesc())
                                }
                            </div>
                        }

                    </div>


                    <div className="crypto-verification-page__content">
                        <div className="crypto-verification-page__content-left">
                            <div className="crypto-verification-page__info">
                                <h2 className="crypto-verification-page__title-h2">{Language.getLabel('L_CRYPTO_CONTENT_TITLE_1')}</h2>
                                <p className="crypto-verification-page__text">
                                    {Language.getLabel('L_CRYPTO_CONTENT_TEXT_1')}
                                </p>

                                <ul className="crypto-verification-page__list-text">
                                    <li className="crypto-verification-page__list-text-item">
                                        <p className="crypto-verification-page__text">{Language.getLabel('L_CRYPTO_CONTENT_LIST_TEXT_1')}</p>
                                    </li>
                                    <li className="crypto-verification-page__list-text-item">
                                        <p className="crypto-verification-page__text">{Language.getLabel('L_CRYPTO_CONTENT_LIST_TEXT_2')}</p>
                                    </li>
                                    <li className="crypto-verification-page__list-text-item">
                                        <p className="crypto-verification-page__text">{Language.getLabel('L_CRYPTO_CONTENT_LIST_TEXT_3')}</p>
                                    </li>
                                </ul>
                            </div>

                            <div className="crypto-verification-page__desc">
                                <h3 className="crypto-verification-page__title-h3">{Language.getLabel('L_CRYPTO_CONTENT_TITLE_2')}</h3>
                                <p className="crypto-verification-page__text">
                                    {Language.getLabel('L_CRYPTO_CONTENT_TEXT_2')}
                                </p>
                            </div>

                            <div className="crypto-verification-page__desc">
                                <h3 className="crypto-verification-page__title-h3">{Language.getLabel('L_CRYPTO_CONTENT_TITLE_3')}</h3>
                                <p className="crypto-verification-page__text">
                                    {Language.getLabel('L_CRYPTO_CONTENT_TEXT_3')}
                                </p>
                                <p className="crypto-verification-page__text">
                                    {Language.getLabel('L_CRYPTO_CONTENT_TEXT_3_1')}
                                </p>
                                <p className="crypto-verification-page__text">
                                    {Language.getLabel('L_CRYPTO_CONTENT_TEXT_3_2')}
                                </p>
                                <p className="crypto-verification-page__text">
                                    {Language.getLabel('L_CRYPTO_CONTENT_TEXT_3_3')} <a className="crypto-verification-page__text-link" href="mailto:support@matbea.com">support@matbea.com</a>
                                </p>
                            </div>
                        </div>
                        <div className="crypto-verification-page__content-right">
                            <img className="crypto-verification-page__img-coin" src="/img/pages/crypto-verification/img-crypto-verification-page-coins.svg" alt="Coins" />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect((store) => {
    return {
        availableCurrencies: store.cryptoAddressVerification.availableCurrencies,
        wallets: store.user.wallets,
        currencies: store.currency,
    };
})(CryptoVerification);